import React, { useState, useEffect } from 'react';
import state from "./State";
import useUpdateOn from "./lib/useUpdateOn";
import * as Events from './Events';
import EventManager from "./lib/EventManager";
import {app} from './initializePixi'
import {levels} from "./StoryLevels";

const useObservable = (object: any, property: string) => useUpdateOn(property+'-changed', object[property])

const useOn = (events: string | string[], callback: Function) => {
  if (typeof events === 'string') events = [events]

  useEffect(() => {
    (events as string[]).forEach(eventName => {
      EventManager.on(eventName, callback)
    })
  },[])

  /*useEffect(() => () => {
    (events as string[]).forEach(eventName => {
      EventManager.off(eventName, callback)
    })
  })*/
}

const ReactApplication = () => {

  // const currentLevel = useUpdateOn('currentLevelIndex-changed', state.currentLevelIndex);
  const currentLevel = useObservable(state, 'currentLevelIndex')
  const selectedAlien = useUpdateOn(Events.glowAlien, 'green')

  const [menuVisible, setMenuVisible] = useState(true)
  const [levelVisible, setLevelVisible] = useState(false)
  const [moves, setMoves] = useState(0)

  useOn([Events.move, Events.undo, Events.setLevel, Events.selectAlien], () => {
    setMoves(state.currentLevel.moves.length)
  })

  const freeHeight = window.innerHeight - app.view.offsetHeight
  if (freeHeight > 90) {
    app.view.style.top = '60px'
  }
  const [hudSize, setHudSize] = useState({
      height: app.view.offsetHeight + (freeHeight > 90 ? 90 : 0),
      width: app.view.offsetWidth
  })

  useOn(Events.screenSizeChanged, () => {
    setHudSize({
      height: app.view.offsetHeight + (freeHeight > 90 ? 90 : 0),
      width: app.view.offsetWidth
    })
  })

  return <>
    <div className='hud' style={{height: hudSize.height + 'px', width: hudSize.width}}>

      <div style={{position: 'absolute', bottom: 0, left: '5px', width: '100%'}}>
        <span> Level {currentLevel + 1} | </span>
        <span> Selected Alien: {selectedAlien} | </span>
        <span> Moves: {moves - 1} </span>
      </div>

      <div className="top-left">
        {state.currentLevel.hasMoreThanOneAlien &&    
        <button style={
          { color: 'rgba(92, 181, 100)',
            backgroundColor: 'rgba(92, 181, 100, 0.2)'
          }} onClick={() => { EventManager.emit(Events.selectAlien, 'green') }} > G </button>
        }
        { state.currentLevel.yellowAlien &&
        <button style={
          { color: 'rgba(244, 235, 100)',
            backgroundColor: 'rgba(244, 235, 100, 0.2)'
          }} onClick={() => { EventManager.emit(Events.selectAlien, 'yellow') }} > Y </button>
        }

        { state.currentLevel.redAlien &&
        <button style={
          { color: 'rgba(231, 65, 75)',
            backgroundColor: 'rgba(231, 65, 75, 0.2)'
          }} onClick={() => { EventManager.emit(Events.selectAlien, 'red') }} > R </button>
        }
      </div>

      <div className="top-right">
        <button onClick={() => { EventManager.emit(Events.undo)}} > [U]NDO </button>
        <button onClick={() => { state.init() }} > [R]ESET </button>
        <button onClick={() => { setMenuVisible(true) }}> MENU </button>
      </div>

    </div>

    {menuVisible &&
      <div className='container'>
        <div className='title'>AlienSmash</div>
        <ul className='menu'>
          <li className='menu-voice' >
            <span onClick={ () => {
                if (state.showContinue) {
                  const confirm = window.confirm('Are you sure you want to start a new game?')
                  if (confirm) {
                    state.resetData();
                    setMenuVisible(false);
                  }
                } else {
                  setMenuVisible(false)
                }
            }}>NEW GAME</span>
          </li>
          {state.showContinue &&
          <li className='menu-voice' >
            <span onClick={ () => {setMenuVisible(false)} }>CONTINUE</span>
          </li>
        }
          <li className='menu-voice' >
            <span onClick={ () => { setLevelVisible(true) } }>SELECT LEVEL</span>
          </li>
          {/* <li className='menu-voice' >
            <span>LEVEL EDITOR</span>
          </li> */}
        </ul>
      </div>
    }

    {levelVisible &&
    <div className='container' style={{overflowY: 'auto'}}>
      <ul className='menu'>
        <li className='menu-voice'><span onClick={() => {
          setMenuVisible(true);
          setLevelVisible(false);
        }}> BACK TO MENU</span></li>
        {levels.map( (level, index) => <li className='menu-voice' key={index}>
          <span
            style={{ color: level.completed ? 'green' : 'red' }}
            onClick={ () => {
              state.setLevel(level)
              state.currentLevelIndex = index
              setMenuVisible(false)
              setLevelVisible(false)
            }}
          >Level {level.name}</span>
        </li>)}
      </ul>
    </div>
    }
    </>
}

export default ReactApplication;
